// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e92b0979","213":"e8a060db","239":"a0fdf85d","306":"74131059","307":"1da3cf60","337":"ee66a9c9","410":"f20c3907","412":"a18206a1","487":"10542a5d","620":"5a83a6c0","664":"ceb396e8","732":"48ca02c3","773":"f11c8dcf","977":"8c425e9a"}[chunkId] + ".chunk.js";
};